/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from 'react';
import LivroLicitacao from 'assets/images/banner_juridicofacil_guia.png';
import DicaLegal from 'assets/images/video_dica_legal.jpg';
import { useDispatch, useSelector } from 'react-redux';
import { get_data_painel } from 'store/modules/juridico_facil_store/actions';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import { ApplicationState } from 'store';
import JuridicoThemeCard from 'components/atoms/juridico_theme_card';
import SearchJuridico from 'components/atoms/search_juridico';
import FilterJuridico from 'components/atoms/filter_juridico';
import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';

const DashboardJuridico = () => {
  const dispatch = useDispatch();

  const { juridico } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  useEffect(() => {
    document.title = 'Jurídico Fácil - ConLicitação';
    dispatch(get_data_painel());
  }, []);

  return (
    <Container>
      <div className="container px-0">
        <div className="row">
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center mb-3">
              <h4 className="mb-1 mr-3 font-weight-bold">Jurídico Fácil</h4>
              <OpenTutorial type="modal" source="juridico" />
            </div>
            <SearchJuridico params={[]} />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-7">
            <h6 className="font-weight-bold text-left">Destaque</h6>
            <div className="card p-3 py-4">
              <iframe
                title="monitoramento-video"
                id="video"
                width="100%"
                height="326.25"
                src={`https://www.youtube-nocookie.com/embed/${juridico?.video?.replace(
                  /https:\/\/youtu.be\//,
                  '',
                )}`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <div className="col-md-5 mt-md-0 mt-3">
            <h6 className="font-weight-bold">Recomendados</h6>
            <a
              href="https://materiais.conlicitacao.com.br/jurisprudencia-licitacao-e-contrato"
              target="_blank"
              rel="noreferrer"
            >
              <img className="card-img-top" src={LivroLicitacao} alt="chat" />
            </a>
            <div className="mt-3">
              {juridico?.recomendados?.map((recomendado) => (
                <div key={recomendado.id} className="card mb-3">
                  <div className="card-body px-3 py-2">
                    <p className="pb-2 mb-0">
                      <strong>{recomendado?.tipo}</strong>
                    </p>
                    <a
                      href={`/juridico/show/${recomendado.id}`}
                      className="link_acervo"
                      dangerouslySetInnerHTML={{
                        __html: recomendado.enunciado,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="row">
          {juridico?.tipo_para_index?.map((tipo) => (
            <JuridicoThemeCard description={tipo?.descricao} id={tipo?.id} />
          ))}
        </div>
        <div className="row mt-3">
          <div className="col-md-3">
            <h6 className="font-weight-bold">Filtrar por</h6>
            <FilterJuridico
              description="Áreas"
              lists={juridico?.area_para_index}
              url="juridico/view/areas/"
            />
            <FilterJuridico
              description="Temas"
              lists={juridico?.tema_para_index}
              url="juridico/view/temas/"
            />
          </div>
          <div className="col-md-9 mt-md-0 mt-3">
            <h6 className="font-weight-bold">Mais vistos</h6>
            {juridico?.mais_vistos?.map((mais_visto) => (
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <nav id="idx_breadcrumb">
                        <ol className="breadcrumb breadcrumb-custom ml-0 pl-0">
                          <li className="breadcrumb-item">
                            <a href="#" data-abc="true">
                              <strong>{mais_visto.tipo}</strong>
                            </a>
                          </li>
                          <li className="breadcrumb-item">
                            <a href="#" data-abc="true">
                              {mais_visto.area}
                            </a>
                          </li>
                          <li className="breadcrumb-item">
                            <a href="#" data-abc="true">
                              {mais_visto.tema}
                            </a>
                          </li>
                          <li className="breadcrumb-item">
                            <a href="#" data-abc="true">
                              {mais_visto.subtema}
                            </a>
                          </li>
                        </ol>
                      </nav>
                    </div>
                    {mais_visto?.dica_em_video !== null && (
                      <div className="col-md-2">
                        <img src={DicaLegal} width="100%" />
                      </div>
                    )}
                    <div className="col-md pl-md-0 pl-3 mt-md-0 mt-3">
                      <a href={`/juridico/show/${mais_visto.id}`} className="link_acervo">
                        {mais_visto.enunciado}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};
export default DashboardJuridico;
